import { MatchCardQuery } from '../types';
import { isValidMatchCard } from './typeguards';
import { CreateMatchCardInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { IMatchCardDataBlock } from '@sky-it-livedata/livedata-sports-design-system';

export default (obj: MatchCardQuery): IMatchCardDataBlock=> {
  if (isValidMatchCard(obj)) {
    CreateMatchCardInputSchema().parse(obj.data.getMatchCard, {reportInput: true});
    const { competition, createdAt, updatedAt, ...matchCard } = obj.data.getMatchCard;

    const validatedMatch = {
      ...matchCard,
      customCompetitionName: competition!.name,
      id: competition!.id,
      link: matchCard.matchDetailUrl,
    } as IMatchCardDataBlock['match'];

    return {
      match: validatedMatch,
      isLoading: false,
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in MatchCardQuery object',
      data: obj
    });
  }
};



